var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpworkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1729 10.9258C22.9013 10.9258 20.4321 13.0863 19.4445 16.4813C17.9013 14.0739 16.6667 11.3579 15.9877 9.01221H12.5309V18.0863C12.5309 19.8764 11.0494 21.3579 9.2593 21.3579C7.46917 21.3579 5.98769 19.8764 5.98769 18.0863V9.07394H2.65436V18.148C2.65436 21.9134 5.67905 24.9381 9.38275 24.9381C13.0865 24.9381 16.1111 21.9134 16.1111 18.148V16.6048C16.7902 17.9628 17.6544 19.4443 18.5803 20.7406L16.4198 30.8023H19.9383L21.4198 23.4566C22.7778 24.3208 24.321 24.8147 26.1729 24.8147C29.9383 24.8147 33.0247 21.7283 33.0247 17.7776C33.0247 14.0122 29.9383 10.9258 26.1729 10.9258ZM26.1729 21.3579C24.8149 21.3579 23.3951 20.7406 22.284 19.8147L22.6544 18.4566V18.3949C22.9013 16.9134 23.7037 14.4443 26.2346 14.4443C28.1482 14.4443 29.6914 15.9875 29.6914 17.9011C29.6297 19.8147 27.963 21.3579 26.1729 21.3579Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpworkIcon);
export default __webpack_public_path__ + "static/media/upwork-icon.995c8e8f2f8a33b68cb132ad45bd2dac.svg";
export { ForwardRef as ReactComponent };